// light themes
@each $c
    in ("white", "robinsBlue", "beige", "trueWhite", "blueTiles", "unthemed")
{
    .#{$c} {
        composes: lightBase from "./composable/themes.module.css";

        @if $c == robinsBlue or $c == blueTiles {
            --color-primary: var(--robins-blue);
        } @else if $c == trueWhite {
            --color-primary: var(--true-white);
        } @else {
            --color-primary: var(--#{$c});
        }

        color: var(--color-contrast);

        @if $c == unthemed {
            background-color: transparent;
        } @else {
            background-color: var(--color-primary);
        }

        @if $c == blueTiles {
            background-image: url("/static/images/goodcook-tile.webp");
            background-repeat: repeat-y;
            background-size: 100% auto;
        }
    }
}

// dark themes
@each $c in ("navy", "midnight") {
    .#{$c} {
        composes: darkBase from "./composable/themes.module.css";

        --color-primary: var(--#{$c});

        color: var(--color-contrast);
        background-color: var(--color-primary);
    }
}
